import { SelectListItem } from './select-property'

export const Options_FileType: SelectListItem[] = [
    { value: "0", text: "CSV File" },
    { value: "1", text: "Text File" },
    { value: "2", text: "XML File" }
];